/**
 * Created by razial on 18.09.2026.
 */

cleverapps.styles.COLORS = cleverapps.overrideColors(cleverapps.styles.COLORS, {
    DAILY_TASK_REWARD_COLOR: new cc.Color(185, 102, 65, 1),
    DAILY_TASK_TIMER_TEXT_COLOR: new cc.Color(191, 130, 107, 1)
});

cleverapps.overrideStyles(cleverapps.styles.DECORATORS, {
    DAILY_TASK_TITLE_STROKE: {
        color: new cc.Color(168, 28, 54, 128),
        size: 3
    }
});

cleverapps.styles.FONTS = cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    DAILY_TASK_PROGRESS_FONT: {
        name: "default",
        size: 30,
        stroke: cleverapps.styles.DECORATORS.IMAGE_FONT_STROKE
    },

    DAILY_TASK_FONT: {
        size: 45,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.DAILY_TASK_TITLE_STROKE
    },

    DAILY_TASK_REWARD_FONT: {
        name: "nostroke",
        size: 30,
        color: cleverapps.styles.COLORS.DAILY_TASK_REWARD_COLOR
    },

    DAILY_TASK_CTA: {
        size: 60,
        color: cleverapps.styles.COLORS.COLOR_WINDOW_TEXT
    },
    DAILY_TASKS_BAR: {
        name: "default",
        size: 30
    },
    DAILY_TASKS_TIMER_TEXT: {
        size: 32,
        name: "nostroke",
        color: cleverapps.styles.COLORS.DAILY_TASK_TIMER_TEXT_COLOR
    }
});

cleverapps.overrideStyles(cleverapps.styles.DailyTasksCompleteAllView, {
    prize: {
        y: { align: "bottom", dy: -14 }
    },

    prizePosition: {
        x: { align: "right", dx: 50 },
        y: { align: "center", dy: 15 }
    },

    padding: {
        left: 60,
        right: 60,
        top: 10,
        bottom: 10
    },

    textLayout: {
        width: cleverapps.config.type === "merge" ? 760 : 520
    },

    bg: {
        width: 850,
        height: 222
    },

    wrapper: {
        anchor: { x: 0.5, y: 0.42 }
    }
});

cleverapps.overrideStyles(cleverapps.styles.DailyTaskTimer, {
    text: {
        width: 360
    }
});

cleverapps.overrideStyles(cleverapps.styles.DailyTasksWindow, {
    tabs: {
        x: { align: "left", dx: -110 },
        height: 150
    },

    window: {
        padding: {
            left: 0,
            right: 0,
            top: 24,
            bottom: 24
        }
    }
});

cleverapps.overrideStyles(cleverapps.styles.DailyTasksTab, {
    foreground: {
        width: 780,
        height: 684,
        y: { align: "center", dy: 2 }
    },

    timer: {
        padding: {
            top: 0,
            bottom: 5
        },
        footer: true
    },

    margin: 15
});

cleverapps.overrideStyles(cleverapps.styles.DailyTaskView, {
    padding: {
        left: 20,
        right: 40,
        top: 20,
        bottom: 30
    },

    titleAndRewards: {
        width: 350,
        y: { align: "center", dy: 10 }
    },

    progressBar: {
        height: 35
    },

    button: {
        height: 70
    },

    margin: 40,
    titleMargin: 10
});

cleverapps.overrideStyles(cleverapps.styles.DailytaskSwapButton, {
    height: 70
});
